import { ResponseModel } from 'Models/ResponseModel';
import { restApiPost } from 'RestApiConnector';

import { ChangePasswordApi } from './ChangePasswordApi';

export class AWSChangePasswordApi implements ChangePasswordApi {
    changePassword = (): Promise<ResponseModel<void>> => {
        return restApiPost('/change_password', {});
    };
}
